module.exports = __webpack_public_path__ + "img/page5-bg.3a96affb.png";